import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsDate,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import { ESecurityTransportKind } from './security.enums';

export class RequestIpEvent extends BasicEntity {
  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: true })
  userId?: number | null;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: false })
  normalizedIp: string;

  @ApiProperty()
  @IsEnum(ESecurityTransportKind, { groups: ['error'] })
  @Column({ type: 'varchar', enum: ESecurityTransportKind, nullable: false })
  transportKind: ESecurityTransportKind;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: false })
  routeKey: string;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: false })
  method: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  userAgentHash?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: true })
  tlsFingerprintHash?: string | null;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Index()
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  occurredAt: Date;
}
